import React from "react";
import Navbar from "../componenets/Navbar";
import Footer from "../componenets/Footer";
import { BookOpen, ShieldCheck, Globe, AlertTriangle, FileText } from "lucide-react";
import "../App.css";

const Regulations = () => {
  return (
    <div className="regulations-page">
      <Navbar />

      <div className="regulations-container">
        <header className="regulations-header">
          <div className="regulations-brand">
            <div className="regulations-logo">
              <BookOpen className="icon-white" />
            </div>
            <div>
              <h1 className="regulations-title">Trade & Customs Regulations</h1>
              <p className="regulations-subtitle">
                Key compliance notes for importers, exporters, and brokers
              </p>
            </div>
          </div>
        </header>

        <div className="regulations-card">
          <h2 className="regulations-section-title">Overview</h2>
          <p className="regulations-text">
            Importers, exporters, and customs brokers must comply with regulations set forth by the
            <strong> Sri Lanka Customs Department</strong> and other relevant authorities. Below are
            the main regulatory areas to be aware of when using the tariff guide.
          </p>
        </div>

        <div className="regulations-grid">
          <div className="regulations-card">
            <div className="regulations-icon-text">
              <FileText className="regulations-icon" />
              <div>
                <h3 className="regulations-card-title">Customs Act & Gazette Notifications</h3>
                <p className="regulations-card-text">
                  Tariff rates, exemptions, and duties are enforced through the Customs Ordinance
                  and updated by Gazette notifications. Always cross-check with the latest gazettes
                  for changes.
                </p>
              </div>
            </div>
          </div>

          <div className="regulations-card">
            <div className="regulations-icon-text">
              <ShieldCheck className="regulations-icon" />
              <div>
                <h3 className="regulations-card-title">Import & Export Control</h3>
                <p className="regulations-card-text">
                  Certain products require Import Control Licenses (ICL) or export permits. This
                  includes restricted items such as pharmaceuticals, arms, and telecom equipment.
                </p>
              </div>
            </div>
          </div>

          <div className="regulations-card">
            <div className="regulations-icon-text">
              <Globe className="regulations-icon" />
              <div>
                <h3 className="regulations-card-title">Trade Agreements & Preferential Tariffs</h3>
                <p className="regulations-card-text">
                  Preferential tariff rates under APTA, SAFTA, and Indo–Sri Lanka FTA apply only if
                  Certificates of Origin (CoO) are presented at clearance.
                </p>
              </div>
            </div>
          </div>

          <div className="regulations-card">
            <div className="regulations-icon-text">
              <AlertTriangle className="regulations-icon" />
              <div>
                <h3 className="regulations-card-title">Prohibited & Restricted Goods</h3>
                <p className="regulations-card-text">
                  Some goods (narcotics, endangered species, counterfeit products) are strictly
                  prohibited. Others may need permits from authorities.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="regulations-card">
          <h2 className="regulations-section-title">Taxation & Levies</h2>
          <p className="regulations-text">
            Besides Customs Duty (CD), imports may attract other levies such as VAT, PAL, Excise
            Duty, CESS, and Luxury Tax. Applicability depends on HS code and product category.
          </p>
        </div>

        <div className="regulations-card regulations-disclaimer">
          <p>
            ⚖️ <strong>Disclaimer:</strong> This information is for guidance only. Always confirm
            with <strong>Sri Lanka Customs</strong> and relevant authorities before making trade
            decisions.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Regulations;
